function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.63891 20.07c0-10.727 8.7061-19.433 19.433-19.433 10.747 0 19.433 8.7061 19.433 19.433 0 10.747-8.6866 19.433-19.433 19.433-10.727 0-19.433-8.6866-19.433-19.433z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(.97127 0 0 .97127 -.52709 -.52879)",
  d: "m1.2005 21.208c0-11.044 8.9636-20.008 20.008-20.008 11.064 0 20.008 8.9636 20.008 20.008 0 11.064-8.9436 20.008-20.008 20.008-11.044 0-20.008-8.9436-20.008-20.008",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.026606 -5.0336)"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m23.78 18.887 0.08866 0.12399c0.83333 0.85026 1.9858 1.364 3.2624 1.364 1.2943 0 2.4468-0.51369 3.2801-1.364l0.08866-0.12399 0.67376 0.1417c1.9681 0.83254 3.3333 2.781 3.3333 5.0306v4.5878l-2.3759 0.86796c-1.6312 0.37199-3.2979 0.56683-5 0.56683-1.6844 0-3.3511-0.19485-4.9822-0.56683l-2.3936-0.86796v-4.5878c0-2.2496 1.383-4.1981 3.3511-5.0306z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m23.78 18.887 0.08866 0.12399c0.83333 0.85026 1.9858 1.364 3.2624 1.364 1.2943 0 2.4468-0.51369 3.2801-1.364l0.08866-0.12399 0.67376 0.1417c1.9681 0.83254 3.3333 2.781 3.3333 5.0306v4.5878l-2.3759 0.86796c-1.6312 0.37199-3.2979 0.56683-5 0.56683-1.6844 0-3.3511-0.19485-4.9822-0.56683l-2.3936-0.86796v-4.5878c0-2.2496 1.383-4.1981 3.3511-5.0306z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m22.592 16.265c0-2.5331 2.039-4.6055 4.539-4.6055 2.5177 0 4.539 2.0725 4.539 4.6055 0 2.5508-2.0213 4.6055-4.539 4.6055-2.5 0-4.539-2.0548-4.539-4.6055z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m22.565 11.231c0-2.5331 2.039-4.6055 4.539-4.6055 2.5177 0 4.539 2.0725 4.539 4.6055 0 2.5508-2.0213 4.6055-4.539 4.6055-2.5 0-4.539-2.0548-4.539-4.6055",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m9.5333 13.853 0.088652 0.12399c0.8156 0.85026 1.9681 1.364 3.2269 1.364 1.2766 0 2.4113-0.51369 3.2447-1.364l0.08865-0.12399 0.67376 0.1417c1.9504 0.83254 3.2979 2.781 3.2979 5.0306v4.5878l-2.3581 0.86796c-1.5957 0.37199-3.2624 0.56683-4.9468 0.56683-1.6666 0-3.3333-0.19485-4.929-0.56683l-2.3759-0.86796v-4.5878c0-2.2496 1.3653-4.1981 3.3156-5.0306z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.5333 13.853 0.088652 0.12399c0.8156 0.85026 1.9681 1.364 3.2269 1.364 1.2766 0 2.4113-0.51369 3.2447-1.364l0.08865-0.12399 0.67376 0.1417c1.9504 0.83254 3.2979 2.781 3.2979 5.0306v4.5878l-2.3581 0.86796c-1.5957 0.37199-3.2624 0.56683-4.9468 0.56683-1.6666 0-3.3333-0.19485-4.929-0.56683l-2.3759-0.86796v-4.5878c0-2.2496 1.3653-4.1981 3.3156-5.0306z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m8.239 11.231c0-2.5331 2.0745-4.6055 4.6099-4.6055 2.5532 0 4.6099 2.0725 4.6099 4.6055 0 2.5508-2.0568 4.6055-4.6099 4.6055-2.5355 0-4.6099-2.0548-4.6099-4.6055z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m8.239 11.231c0-2.5331 2.0745-4.6055 4.6099-4.6055 2.5532 0 4.6099 2.0725 4.6099 4.6055 0 2.5508-2.0568 4.6055-4.6099 4.6055-2.5355 0-4.6099-2.0548-4.6099-4.6055",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m16.437 16.262 0.08866 0.1417c0.90425 0.9034 2.1632 1.4703 3.546 1.4703 1.4007 0 2.6596-0.56683 3.5638-1.4703l0.08866-0.1417 0.74468 0.15942c2.1277 0.90339 3.617 3.0113 3.617 5.4735v4.9775l-2.5886 0.95654c-1.7553 0.40741-3.5815 0.61997-5.4255 0.61997-1.8262 0-3.6524-0.21256-5.4078-0.61997l-2.6064-0.95654v-4.9775c0-2.4622 1.5071-4.5701 3.6347-5.4735z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m16.437 16.262 0.08866 0.1417c0.90425 0.9034 2.1632 1.4703 3.546 1.4703 1.4007 0 2.6596-0.56683 3.5638-1.4703l0.08866-0.1417 0.74468 0.15942c2.1277 0.90339 3.617 3.0113 3.617 5.4735v4.9775l-2.5886 0.95654c-1.7553 0.40741-3.5815 0.61997-5.4255 0.61997-1.8262 0-3.6524-0.21256-5.4078-0.61997l-2.6064-0.95654v-4.9775c0-2.4622 1.5071-4.5701 3.6347-5.4735z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m15.037 13.286c0-2.7279 2.2695-4.9598 5.0354-4.9598 2.7837 0 5.0354 2.2319 5.0354 4.9598 0 2.7456-2.2517 4.9598-5.0354 4.9598-2.766 0-5.0354-2.2142-5.0354-4.9598z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m15.037 13.286c0-2.7279 2.2695-4.9598 5.0354-4.9598 2.7837 0 5.0354 2.2319 5.0354 4.9598 0 2.7456-2.2517 4.9598-5.0354 4.9598-2.766 0-5.0354-2.2142-5.0354-4.9598",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref12 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.93958 0 0 .94602 1.6641 18.19)"
}, React.createElement("path", {
  d: "m11.72 6.8321c0-1.2292 1.0421-2.2945 2.2445-2.2945h11.223c1.2425 0 2.2445 1.0653 2.2445 2.2945v9.1779c0 1.2702-1.002 2.2945-2.2445 2.2945h-11.223c-1.2024 0-2.2445-1.0243-2.2445-2.2945z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeWidth: 1.134
}), React.createElement("path", {
  className: "icon-primary",
  d: "m13.845 12.834 3.4069 3.447 8.2166-7.415-2.2846-2.4049-5.5312 7.4551-1.7235-2.6053z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  strokeWidth: 1.134
}), React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.0607
}, React.createElement("path", {
  d: "m11.541 6.842c0-1.2345 1.058-2.3045 2.2788-2.3045h11.394c1.2615 0 2.2788 1.0699 2.2788 2.3045v9.2178c0 1.2757-1.0173 2.3045-2.2788 2.3045h-11.394c-1.2208 0-2.2788-1.0288-2.2788-2.3045z"
}), React.createElement("path", {
  d: "m13.845 12.834 3.4069 3.447 8.2166-7.415-2.2846-2.4049-5.5312 7.4551-1.7235-2.6053z"
})));
var SvgDefineSurveyTabParticipants = function SvgDefineSurveyTabParticipants(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefineSurveyTabParticipants, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Define-Survey-Tab-Participants.365df351.svg";
export { ForwardRef as ReactComponent };